import * as ACTION_TYPES from '../types';

let initialState = {
  photoList: [],
  photo: {},
  photos_by_query: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTION_TYPES.GET_PHOTOS:
      return { ...state, photoList: action.data };
    case ACTION_TYPES.DELETE_PHOTOS:
    let newList = state.photoList.filter(photo => photo._id !== action.id);
      return {...state, photoList: newList };
    case ACTION_TYPES.REQUEST:
      return { ...state, loading: true };
    case ACTION_TYPES.DONE:
      return { ...state, loading: false };
    case ACTION_TYPES.RESET_PHOTOS:
      return { ...state, photoList: [] };
    case ACTION_TYPES.GET_PHOTO_BY_ID:
      return { ...state, photo: action.data }
    case ACTION_TYPES.GET_PHOTOS_BY_QUERY:
      return { ...state, photos_by_query: action.data }
    default:
      return state;
  }
};